export const userRoleOptions = [
  {
    value: "student",
    extraClassName: "!text-[#76A6C4] !bg-[#E7F4FC]",
  },
  {
    value: "teacher",
    extraClassName: "!text-[#DD914A] !bg-[#FFEFB7]",
  },
  {
    value: "school_admin",
    extraClassName: "!text-[#EB6244] !bg-[#FFCAB4]",
  },
  {
    value: "private_user",
    extraClassName: "!text-gray-400 !bg-gray-100",
  },
  {
    value: "superadmin",
    extraClassName: "!text-green-400 !bg-green-100",
  },
];
export const userRoleOptionsForSchoolAdmin = [
  {
    value: "student",
    extraClassName: "!text-[#76A6C4] !bg-[#E7F4FC]",
  },
  {
    value: "teacher",
    extraClassName: "!text-[#DD914A] !bg-[#FFEFB7]",
  },
  {
    value: "school_admin",
    extraClassName: "!text-[#EB6244] !bg-[#FFCAB4]",
  },
];

export const userStatusOptions = [
  {
    value: "0",
  },
  {
    value: "1",
  },
  {
    value: "2",
  },
  {
    value: "3",
  },
  {
    value: "4",
  },
];

export const subscriptionPresenceOptions = [
  {
    value: "yes",
  },
  {
    value: "no",
  },
];

export const USER_ROLES = {
  PRIVATE_USER: "private_user",
  TEACHER: "teacher",
  SCHOOL_ADMIN: "school_admin",
  STUDENT: "student",
  SUPERADMIN: "superadmin",
};
